import { render, staticRenderFns } from "./TraeUnAmigo.vue?vue&type=template&id=e925e304&scoped=true&"
import script from "./TraeUnAmigo.vue?vue&type=script&lang=js&"
export * from "./TraeUnAmigo.vue?vue&type=script&lang=js&"
import style0 from "./TraeUnAmigo.vue?vue&type=style&index=0&id=e925e304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e925e304",
  null
  
)

export default component.exports